import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import injectSheet from "react-jss";
import { Typography } from "@material-ui/core";

import ObservacoesAtividades from "../components/Observacoes/ObservacoesAtividades";
import { Flex } from "../../../../_common";

const style = () => ({
  containerSemObservacao: {
    marginTop: 24,
  },
  textoSemObservacao: {
    fontStyle: "italic",
    color: "#a5aab4",
  },
});

function AbaObservacoes({ atividades, isAtividadeEmMassa, classes }) {
  const intl = useIntl();

  const atividadesComObservacoes = atividades.filter(
    atividade => atividade.observacoes && atividade.observacoes.trim() !== ""
  );

  return (
    <>
      {atividadesComObservacoes.length > 0 ? (
        atividadesComObservacoes.map(atividade => (
          <ObservacoesAtividades key={atividade.id} atividade={atividade} isAtividadeEmMassa={isAtividadeEmMassa} />
        ))
      ) : (
        <Flex center className={classes.containerSemObservacao}>
          <Typography variant="body1" className={classes.textoSemObservacao}>
            {intl.formatMessage({ defaultMessage: "Não há observações" })}
          </Typography>
        </Flex>
      )}
    </>
  );
}

AbaObservacoes.propTypes = {
  atividades: PropTypes.array,
  isAtividadeEmMassa: PropTypes.bool,
};

export default injectSheet(style)(AbaObservacoes);
